import { ICONS } from "../../lib/constants";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { TagInput, COLORS } from "./wizardShared";

export default function StepBasics({ pack, setPack }) {
  return (
    <div className="bg-[var(--c-surface)] border border-[var(--c-border)] rounded-lg shadow-sm p-5 space-y-4 max-w-2xl" data-testid="wizard-basic">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label className="text-[var(--c-muted)] text-xs">Pack name *</Label>
          <Input data-testid="pack-name" value={pack.name} onChange={(e) => setPack({ ...pack, name: e.target.value })}
            className="bg-[var(--c-bg)] border-[var(--c-border)] text-[var(--c-text)]" placeholder="e.g., Power Transformers" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-[var(--c-muted)] text-xs">Status</Label>
          <Select value={pack.status} onValueChange={(v) => setPack({ ...pack, status: v })}>
            <SelectTrigger data-testid="pack-status" className="bg-[var(--c-bg)] border-[var(--c-border)] text-[var(--c-text)]"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-[var(--c-surface)] border-[var(--c-border)]">
              <SelectItem value="active" className="text-[var(--c-text)] focus:bg-[var(--c-surface-2)]">Active</SelectItem>
              <SelectItem value="draft" className="text-[var(--c-text)] focus:bg-[var(--c-surface-2)]">Draft</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="space-y-1.5">
        <Label className="text-[var(--c-muted)] text-xs">Description</Label>
        <Input data-testid="pack-desc" value={pack.description} onChange={(e) => setPack({ ...pack, description: e.target.value })}
          className="bg-[var(--c-bg)] border-[var(--c-border)] text-[var(--c-text)]" placeholder="What this industry manufactures" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label className="text-[var(--c-muted)] text-xs">Icon</Label>
          <Select value={pack.icon} onValueChange={(v) => setPack({ ...pack, icon: v })}>
            <SelectTrigger data-testid="pack-icon" className="bg-[var(--c-bg)] border-[var(--c-border)] text-[var(--c-text)]"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-[var(--c-surface)] border-[var(--c-border)]">
              {Object.keys(ICONS).map((k) => {
                const Ic = ICONS[k];
                return <SelectItem key={k} value={k} className="text-[var(--c-text)] focus:bg-[var(--c-surface-2)]"><span className="inline-flex items-center gap-2"><Ic size={13} />{k}</span></SelectItem>;
              })}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label className="text-[var(--c-muted)] text-xs">Badge color</Label>
          <div className="flex gap-2 pt-1.5">
            {COLORS.map((c) => (
              <button key={c} type="button" data-testid={`pack-color-${c.slice(1)}`} onClick={() => setPack({ ...pack, color: c })}
                className={`w-7 h-7 rounded-sm border-2 transition-colors duration-150 ${pack.color === c ? "border-[var(--c-text)]" : "border-transparent"}`}
                style={{ backgroundColor: c }} />
            ))}
          </div>
        </div>
      </div>
      <div className="space-y-1.5">
        <Label className="text-[var(--c-muted)] text-xs">Base units</Label>
        <Select value={pack.base_units} onValueChange={(v) => setPack({ ...pack, base_units: v })}>
          <SelectTrigger data-testid="pack-units" className="bg-[var(--c-bg)] border-[var(--c-border)] text-[var(--c-text)] w-64"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-[var(--c-surface)] border-[var(--c-border)]">
            <SelectItem value="metric" className="text-[var(--c-text)] focus:bg-[var(--c-surface-2)]">Metric</SelectItem>
            <SelectItem value="imperial" className="text-[var(--c-text)] focus:bg-[var(--c-surface-2)]">Imperial</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-[var(--c-muted)] text-xs">Applicable standards (press Enter to add)</Label>
        <TagInput testid="pack-standards" tags={pack.standards} onChange={(standards) => setPack({ ...pack, standards })} placeholder='e.g., "IEC 60076", "IS 2026"' />
      </div>
    </div>
  );
}
